import { SyntheticEvent, useState } from 'react'

export type FormTabsProps = {
  index: number
  label: string
  icon: any
  content?: any
}

export const useTab = (tabs: FormTabsProps[]) => {
  const [current, setCurrent] = useState(0)

  const totalOfTabs = tabs.length
  const isLast = current === tabs.length - 1
  const isFirst = current === 0

  const handleNext = () => {
    const newCurrentStep = Math.max(current + 1, 0)
    setCurrent(newCurrentStep)
  }

  const handlePrev = () => {
    const newCurrentStep = Math.max(current - 1, 0)
    setCurrent(newCurrentStep)
  }

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setCurrent(newValue)
  }

  return {
    tab: {
      current,
      isFirst,
      isLast,
      totalOfTabs,
    },
    handleChange,
    handleNext,
    handlePrev,
  }
}
